// Generated with tools/create-component.js
import React from "react";
import { Carousel, CarouselTypes, CmsContent, Container, Image } from "components";
import { ContainerWidthEnum } from "utils";
import { SliderMicroQueryFragment } from "codegen";
import "./SliderMicro.scss";

interface SliderMicroProps {
  data: SliderMicroQueryFragment;
}

export const SliderMicro: React.FC<SliderMicroProps> = ({ data: { intro, images } }): JSX.Element => {
  const swiperSettings: CarouselTypes = {
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 70,
    grabCursor: false,
    pagination: false,
    navigation: true,
    initialSlide: Math.round(images.length / 2),
    breakpoints: {
      600: {
        initialSlide: Math.round(images.length / 2.5),
        slidesPerView: "auto",
      },
    },
  };

  return (
    <Container className="slider-micro" containerWidth={ContainerWidthEnum["FULL_BLEED_LARGE"]}>
      {intro && <CmsContent content={intro} />}
      {images && (
        <Carousel swiperSettings={swiperSettings}>
          {(images as string[]) && images.map((image, index) => <Image src={image} key={index} />)}
        </Carousel>
      )}
    </Container>
  );
};
